/*jshint esversion: 6 */
// import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';
// import router from '@/router/index';


const initialState = () => ({
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getShoppingCartTotal: (state, getters, rootState) => () => {
    let total = 0;
    let products = Object.keys(rootState.Ultra.shoppingcartproducts).map(id => rootState.Ultra.shoppingcartproducts[id]);
    for (let i = 0; i < products.length; i++) {
      total += (products[i].cost * products[i].amount);
    }
    return total;
  },
  getMonthlySubscriptionFee: (state, getters, rootState) => () => {
    let total = 0;
    let products = Object.keys(rootState.Ultra.orderedproducts).map(id => rootState.Ultra.orderedproducts[id]);
    for (let i = 0; i < products.length; i++) {
      if (products[i].recurrence === 'monthly') {
        total += (products[i].cost * products[i].amount);
      }
    }
    return total;
  },
};
// Actions
const actions = {
  checkoutShoppingCart({commit, rootState}, payload){
    axios({
      url: 'shoppingcarts/' + rootState.Ultra.shoppingcarts[Object.keys(rootState.Ultra.shoppingcarts)[0]].id + '/checkout?show=showWithEntitiesNormalized',
      method: 'PUT',
      data: { instant_invoice: payload.instant_invoice },
    })
    .then(resp => {
      commit('checkout', rootState);
      let my_payload = {
        resp_data: resp.data.data
      };
      commit('Ultra/create_u_objects', {rootState, my_payload}, { root: true });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  }
};
// Mutations
const mutations = {
  //local state mutations
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  checkout(state, rootState){
    // clear shopping cart
    rootState.Ultra.shoppingcarts[Object.keys(rootState.Ultra.shoppingcarts)[0]].shoppingcartproducts = [];
    rootState.Ultra.shoppingcartproducts = {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
